import * as React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import PageTitle from "../../components/page-title"
import Section from "../../components/section"
import SectionTitle from "../../components/section-title"
import List from "../../components/list"
import ListItem from "../../components/list-item"

const ProcurementPolicy = () => {
  return (
    <Layout>
      <PageTitle
        title={"Procurement Policy"}
        pageParentTitle={"Policies"}
        pageParentPath={"/policies"}
        backgroundImage={"18.jpg"}
      />
      <Section>
        <SectionTitle title={"Mission Statement"} size={"text-3xl"} />
        <p>
          To provide high quality, value for money match, training, and coaching
          kit to ensure a uniformity of identity is achieved across all age
          groups. To ensure that all equipment is of the highest standard and
          value for money to make certain that every player has an equal
          opportunity.
        </p>
        <SectionTitle title={"Match / Playing Kits"} size={"text-3xl"} />
        <p>
          Match and Training kits are purchased directly from Norwich based
          company 99Kits. We are currently standardizing our playing and
          training range to ensure that the club has a consistent identity. The
          brand we have chosen is Joma, for both their quality and value for
          money.
        </p>
        <p>Orders can be placed as follows:</p>
        <List>
          <ListItem>
            All player kits sponsored or otherwise are ordered via an online
            form provided by the club’s Procurement Officer
          </ListItem>
          <ListItem>
            All coach’s kit is ordered via an online form provided by the club’s
            Procurement Officer
          </ListItem>
          <ListItem>
            Player training kits and other items such as travel, and training
            wear are purchased directly by parents/players via our 4Sports
            online club shop
          </ListItem>
        </List>
        <SectionTitle
          title={"Coaching / Playing Equipment"}
          size={"text-3xl"}
        />
        <p>
          Other club provided items such as balls, bibs, poles, cones, and First
          Aid kits are ordered via the club’s Procurement Officer and purchased
          from several online vendors ensuring best value is achieved.
        </p>
        <p>
          Match goals are purchased directly from MH Goals by the club’s
          Procurement Officer.
        </p>
        <p>
          The club will not reimburse coaches or parents for any items bought
          without prior written permission.
        </p>
        <SectionTitle title={"Suppliers"} size={"text-3xl"} />
        <p>The club currently purchase from the following vendors:</p>
        <List>
          <ListItem>4Sports</ListItem>
          <ListItem>MH Goals</ListItem>
          <ListItem>A.C. Leigh</ListItem>
          <ListItem>Vesey</ListItem>
          <ListItem>Newitts</ListItem>
          <ListItem>Amazon (including Amazon Marketplace)</ListItem>
        </List>
      </Section>
    </Layout>
  )
}

export const Head = () => (
  <Seo
    title="Procurement Policy"
    description={
      "To provide high quality, value for money match, training, and coaching kit to ensure a uniformity of identity is achieved across all age groups."
    }
  />
)

export default ProcurementPolicy
